import { createAction, props } from '@ngrx/store';

import { GlobalEvent } from './models/global-event.model';

export const dispatch = createAction('[Event] Dispatch', props<GlobalEvent>());
